import { RECEIVED_GET_USER_TYPES } from "../actions";

const initialState = [];

const reducerUserTypes = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVED_GET_USER_TYPES:
      return action.payload;
    default:
      return state;
  }
};

export default reducerUserTypes;
